import { environment } from '@/env/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CheckReservationRepository } from '@/core/domain/check-reservation/repositories/check-reservation.repository';
import { CheckReservationResponse } from '@/core/domain/check-reservation/models/check-response.model';
import { CheckReservation } from '@/core/domain/check-reservation/models/check-body.model';

@Injectable({
    providedIn: 'root',
})
export class CheckReservationImplRepository extends CheckReservationRepository {
    constructor(private readonly httpClient: HttpClient) {
        super();
    }

    override checkReservation(
        checkReservation: CheckReservation,
    ): Observable<CheckReservationResponse> {
        return this.httpClient.post(
            [
                environment.alamoApi.BASE_HOST,
                environment.alamoApi.ENDPOINTS.checkReservation,
            ].join('/'),
            checkReservation,
        );
    }
}
